/*
 * Copyright (c) 2021, salesforce.com, inc.
 * All rights reserved.
 * SPDX-License-Identifier: BSD-3-Clause
 * For full license text, see the LICENSE file in the repo root or https://opensource.org/licenses/BSD-3-Clause
 */
export default {
    baseStyle: {
        container: {
            backgroundColor: 'black',
            position: 'relative',
            borderRadius: '30px',
            overflow: 'hidden'
        },
        orangeCircle: {
            position: 'absolute',
            backgroundColor: 'yellow.400',
            border: '1px solid',
            borderRadius: '50%'
        },
        headline: {
            color: 'white',
            marginBottom: 5
        },
        mobileProductImage: {
            position: 'absolute',
            bottom: {base: '-90px', md: '-120px'},
            right: {base: '-10px', md: '-30px'},
            width: {base: '180px', md: '330px'}
        }
    },
    variants: {
        imageLeftTextRight: {
            container: {
                marginBottom: {lg: '5rem'},
                justifyContent: {xl: 'space-around'}
            },
            orangeCircle: {
                width: {base: '163px', md: '300px', xl: '560px'},
                height: {base: '163px', md: '300px', xl: '560px'},
                top: {base: 'auto', xl: '-290px'},
                bottom: {base: '-50px', xl: 'auto'},
                left: {base: 'auto', xl: '50px'},
                right: {base: '-50px', xl: 'auto'}
            }
        },
        textLeftImageRight: {
            container: {
                padding: {xl: '50px 0 40px 40px'},
                marginTop: {lg: '10rem'}
            },
            orangeCircle: {
                width: {base: '210px', md: '310px', xl: '544px'},
                height: {base: '210px', md: '310px', xl: '544px'},
                top: {base: 'auto', xl: '-200px'},
                bottom: {base: '-50px', xl: 'auto'},
                left: {base: 'auto', xl: 'auto'},
                right: {base: '-120px', xl: '-190px'}
            },
            horseShoe: {
                position: 'absolute',
                width: {base: '122px', md: '200px', xl: '416px'},
                bottom: {base: '-50px', md: '-72px', xl: '-120px'},
                right: '0',
                zIndex: 1
            },
            iphone: {
                position: 'absolute',
                width: {base: '70px', md: '140px', xl: '261px'},
                top: {base: '-auto', xl: '-35px'},
                bottom: {base: '50px', xl: 'auto'},
                right: {base: '40px', md: '110px', xl: '175px'}
            },
            signet: {
                position: 'absolute',
                width: {base: '52px', md: '120px', xl: '178px'},
                top: {base: 'auto', xl: '85px'},
                bottom: {base: '85px', md: '132px', xl: 'auto'},
                right: {base: '0', md: '4px', xl: '30px'},
                zIndex: 2
            }
        }
    },
    parts: [
        'container',
        'orangeCircle',
        'headline',
        'mobileProductImage',
        'horseShoe',
        'iphone',
        'signet'
    ]
}
